import { useState } from 'react'
import { Controller } from 'react-hook-form'
import InputFormCard from '@component/InputFormCard'
import UnitAdornment from '@component/UnitAdornment'
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { useHistoryList } from '@component/HistoryList'
import { useTranslation } from 'react-i18next'
import { SLAB_TYPE } from '@core/const'
import { Query } from '@core/query'
import { useOneWaySlab } from './context'
import { makeFormRules, toMillimeter } from '@/utils'

function OneWaySlabForm () {
  const { t } = useTranslation()

  const { form, setResult } = useOneWaySlab()
  const { appendHistory } = useHistoryList()

  const {
    control,
    reset,
    handleSubmit,
  } = form

  const rules = makeFormRules()

  const [isLoading, setLoading] = useState(false)
  const onSubmit = handleSubmit(async _ => {
    if (_.beamSpan <= 0) {
      alert(t('SENTENCE.CHECK_YOUR_INPUT'))
      return
    }

    setLoading(true)
    const res = await Query.requestCalcOneWaySlab(_)
    setLoading(false)

    const needThickness = toMillimeter(res.needThickness)
    setResult(needThickness)
    appendHistory({
      type: 'OneWaySlab',
      ..._,
      result: needThickness,
    })
  })

  const onReset = () => {
    reset()
    setResult(null)
  }

  return (
    <InputFormCard
      title={t('GLOSSARY.ONE_WAY_SLAB')}
      onReset={onReset}
      onSubmit={onSubmit}
      loading={isLoading}
    >
      <FormControl variant="standard">
        <InputLabel>
          {t('GLOSSARY.SLAB_TYPE')}
        </InputLabel>
        <Controller
          control={control}
          name="slabType"
          render={({ field }) => (
            <Select
              renderValue={_ => t(`GLOSSARY.${_}`)}
              {...field}
            >
              {Object.keys(SLAB_TYPE).map(_ => (
                <MenuItem key={_} value={_}>
                  {t(`GLOSSARY.${_}`)}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </FormControl>
      <Controller
        name="beamSpan"
        control={control}
        rules={rules}
        render={({ field, fieldState }) => (
          <TextField
            label={t('GLOSSARY.SHORTSIDE_SPAN')}
            InputProps={{
              endAdornment: <UnitAdornment unit="m" />,
            }}
            {...field}
            error={fieldState.invalid}
          />
        )}
      />
    </InputFormCard>
  )
}

export default OneWaySlabForm
